<app-slider></app-slider>
<app-introduction></app-introduction>
<app-services></app-services>
<app-edalat></app-edalat>
<app-sejam></app-sejam>
<app-new-solutions></app-new-solutions>
<app-new-investments></app-new-investments>